import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { CountdownTimer } from './CountdownTimer';
export function CountdownScarcity() {
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    // Animate progress bar on mount
    const timer = setTimeout(() => {
      setProgress(68);
    }, 500);
    return () => clearTimeout(timer);
  }, []);
  return <section className="w-full bg-deep-green py-16 px-4" data-id="element-51">
      <div className="max-w-3xl mx-auto text-center" data-id="element-52">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl md:text-3xl font-bold text-white mb-8" data-id="element-53">
          ⏰ EL PRECIO DE LANZAMIENTO TERMINA EN:
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} data-id="element-54">
          <CountdownTimer data-id="element-55" />
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3
      }} className="text-gold font-bold text-lg md:text-xl mt-6 mb-12" data-id="element-56">
          Después sube $10.000 ARS y no vuelve a bajar.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="max-w-md mx-auto bg-black/20 rounded-xl p-6 border border-white/10" data-id="element-57">
          <div className="flex items-center justify-center gap-2 mb-4" data-id="element-58">
            <span className="text-red-500 text-xl" data-id="element-59">🔴</span>
            <span className="text-white font-medium" data-id="element-60">
              Cupos al precio de lanzamiento
            </span>
          </div>

          <div className="w-full h-4 bg-black rounded-full overflow-hidden mb-3" data-id="element-61">
            <motion.div className="h-full bg-gold" initial={{
            width: '0%'
          }} animate={{
            width: `${progress}%`
          }} transition={{
            duration: 1.5,
            ease: 'easeOut'
          }} data-id="element-62" />
          </div>

          <p className="text-green-100 text-sm font-medium" data-id="element-63">
            68% de los cupos tomados — Quedan pocos disponibles
          </p>
        </motion.div>
      </div>
    </section>;
}